module.exports = __webpack_public_path__ + "img/default-banner.ac135724.png";